"use client";
import { useDebouncer } from "@tanstack/react-pacer/debouncer";
import clsx from "clsx";
import { useRouter } from "next/navigation";
import { type ChangeEventHandler, type KeyboardEventHandler, useEffect, useRef, useState } from "react";
import type { SpeakersSearch } from "../page";

type Props = {
  search: SpeakersSearch;
};
export const Search = ({ search }: Props) => {
  const router = useRouter();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchText, setSearchText] = useState(search.n || "");
  const [hasFocus, setFocus] = useState(false);

  useEffect(() => {
    if (search.n) setSearchText(search.n);
  }, [search]);

  const updateUrl = (value: string) => {
    if (value === "") {
      router.replace("/conferenciers/");
    } else {
      router.replace(`/conferenciers/?n=${value}`);
    }
  };

  const setSearchDebouncer = useDebouncer(updateUrl, {
    wait: 225,
  });

  const handleInputChangeNew: ChangeEventHandler<HTMLInputElement> = (e) => {
    setSearchText(e.target.value);
    setSearchDebouncer.maybeExecute(e.target.value);
  };

  const handleSubmit: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      //
    }
  };

  const handleBarClick: React.MouseEventHandler<Element> = (e) => {
    e.stopPropagation();
    inputRef.current?.focus();
  };

  return (
    <div
      className="w-full bg-bg-1 border border-bg-2 px-4 rounded-lg h-14 flex relative items-center"
      onClick={handleBarClick}
    >
      <div className="w-full flex flex-col h-14 justify-center">
        <p
          className={clsx("text-xs text-tx-2 transition", {
            "opacity-0 -translate-y-4": hasFocus,
          })}
        >
          Rechercher
        </p>
        <div
          className={clsx("inline-block h-5 max-h-5 border-0 w-full transition-transform", {
            "-translate-y-2": hasFocus,
          })}
        >
          <div className="h-5 w-full flex items-center">
            <input
              ref={inputRef}
              className={clsx(
                "bg-bg-1 w-auto grow focus:outline-hidden block min-w-0 text-tx-1 text-base leading-5 font-semibold placeholder:transition-opacity placeholder:text-tx-1 placeholder:text-base placeholder:leading-5 placeholder:font-semibold",
                {
                  "placeholder:opacity-0": hasFocus,
                },
              )}
              value={searchText}
              onFocus={() => setFocus(true)}
              onBlur={() => setFocus(false)}
              onChange={handleInputChangeNew}
              onKeyDown={handleSubmit}
              placeholder="Saisissez le nom ou le prénom d’un conférencier"
              onMouseUp={(e) => e.preventDefault()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
